import { useState, useEffect, Suspense, lazy } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Sparkles, Trophy, Clock, Palmtree, UserCircle, Users, Loader2, Lock, CalendarClock } from "lucide-react";

const BienestarPage = lazy(() => import("./equipo/BienestarPage"));
const GamificationPage = lazy(() => import("./equipo/GamificationPage"));
const TimesheetsPage = lazy(() => import("./equipo/TimesheetsPage"));
const VacacionesPage = lazy(() => import("./equipo/VacacionesPage"));
const TalentOSPage = lazy(() => import("./equipo/TalentOSPage"));
const ShakersPage = lazy(() => import("./equipo/ShakersAdminPage"));
export { ShakersPage };
const BitacoraPage = lazy(() => import("./equipo/BitacoraPage"));

const TABS = [
  { key: "bitacora", label: "Bitácora", icon: CalendarClock, comp: "BitacoraPage", show: () => true },
  { key: "bienestar", label: "Bienestar", icon: Sparkles, comp: "BienestarPage", show: () => true },
  { key: "gamificacion", label: "Gamificación", icon: Trophy, comp: "GamificationPage", show: () => true },
  { key: "timesheets", label: "Timesheets", icon: Clock, comp: "TimesheetsPage", show: () => true },
  { key: "mytime", label: "MyTime Equipo", icon: Palmtree, comp: "VacacionesPage", show: () => true },
  { key: "talent", label: "Talent OS", icon: UserCircle, comp: "TalentOSPage", show: () => true },
];

const COMPS = { BienestarPage, GamificationPage, TimesheetsPage, VacacionesPage, TalentOSPage, BitacoraPage };

export default function EquipoPage() {
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const [tab, setTab] = useState(params.get("tab") || "bitacora");
  useEffect(() => {
    if (tab !== params.get("tab")) setParams({ tab }, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);

  const visibleTabs = TABS.filter((t) => t.show(user));

  return (
    <div className="p-6 space-y-4" data-testid="equipo-page">
      <div className="border-b pb-4">
        <div className="text-xs uppercase tracking-widest text-emerald-700 font-semibold mb-1">Innovation OS · Equipo</div>
        <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
          <Users className="w-6 h-6 text-emerald-600" /> Equipo &amp; Cultura
        </h1>
        <p className="text-sm text-muted-foreground mt-1">Bitácora · Bienestar · Gamificación · Timesheets · MyTime · Talent OS.</p>
      </div>

      <Tabs value={tab} onValueChange={setTab} className="space-y-4">
        <TabsList className="flex-wrap h-auto">
          {TABS.map((t) => {
            const Icon = t.icon;
            const enabled = t.show(user);
            return (
              <TabsTrigger key={t.key} value={t.key} disabled={!enabled} data-testid={`equipo-tab-${t.key}`}>
                {enabled ? <Icon className="w-4 h-4 mr-2" /> : <Lock className="w-4 h-4 mr-2" />} {t.label}
              </TabsTrigger>
            );
          })}
        </TabsList>

        <div className="-mx-6 -mt-2">
          <Suspense fallback={<div className="p-12 flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-emerald-600" /></div>}>
            {visibleTabs.map((t) => {
              const Comp = COMPS[t.comp];
              return (
                <TabsContent key={t.key} value={t.key} className="mt-0">
                  <Comp />
                </TabsContent>
              );
            })}
          </Suspense>
        </div>
      </Tabs>
    </div>
  );
}
